import { ExclamationTriangleIcon, TrashIcon, UserMinusIcon, UserPlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useRef, useState } from "react";
import { useClickOutsideBlock } from "../../helpers/useClickOutside";
import { LoaderSpinner } from "../LoaderSpinner";

export const RemoveUserModal = ({
    isOpen,
    isLoading,
    user,
    cancelClick,
    submitClick,
}) => {
    const modalRef = useRef(null);
    const [confirmMessage, setConfirmMessage] = useState("");
    useClickOutsideBlock(modalRef, cancelClick);
    if (!isOpen) return null;
    return (
        <div aria-hidden="true" className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-40 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full">
            <div className="bg-gray-700 top-0 right-0 left-0 fixed z-40 justify-center items-center w-full md:inset-0 h-[calc(100%)] max-h-full opacity-30" />
            <div ref={modalRef} className={`relative p-5 w-full max-w-lg max-h-full bg-white border top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 rounded-md`}>
                <div className="flex justify-end">
                    <button 
                        onClick={cancelClick}
                        className="inline-flex items-center p-1 text-primary absolute"
                    >
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                    </button>
                </div>
                <div className="flex flex-col gap-4 text-center sm:text-left">
                    <h2 className="text-lg leading-none font-semibold flex items-center gap-2">
                        <TrashIcon className="h-6 w-6 text-red-500"/>
                        <span>Remove User</span>
                    </h2>
                    <p className="text-gray-700/90 text-sm">
                        This action cannot be undone. All user data and access will be permanently removed.
                    </p>
                </div>
                <div className="space-y-4 my-4">
                    <div className="relative w-full rounded-lg border px-4 py-3 text-sm grid gap-2 items-start text-red-500 bg-gray-50">
                        <ExclamationTriangleIcon className="h-5 w-5 text-red-500" />
                        <div className="text-red-500 col-start-2 grid justify-items-start gap-1 text-sm">
                            <strong>Warning:</strong>
                            <p>
                                This will permanently delete {user?.name || ""}'s account and all associated data.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="space-y-2 mb-4">
                    <label className="flex items-center gap-2 text-sm leading-none font-medium select-none">
                        Type <code className="bg-gray-50 px-1 rounded">DELETE {user?.name || ""}</code> to confirm:
                    </label>
                    <input
                        value={confirmMessage}
                        onChange={(e) => setConfirmMessage(e.target.value)}
                        placeholder={`DELETE ${user?.name || ""}`}
                        className="border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
                    />
                </div>
                <div className="flex justify-end gap-2">
                    <button 
                        onClick={() => {
                            cancelClick()
                        }}
                        className="min-w-20 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm"
                    >
                        {isLoading ? <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray"/> : "Cancel"}
                    </button>
                    <button 
                        onClick={() => {
                            if (!isLoading) {
                                submitClick(user?.id);
                            }
                        }}
                        disabled={confirmMessage !== `DELETE ${user?.name || ""}`}
                        className="min-w-24 justify-center inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white disabled:opacity-50 bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                    >
                        {isLoading ? <LoaderSpinner width="20" height="20" border="3" colorSpinner="gray"/> : "Remove User"}
                    </button>
                </div>
            </div>
        </div>
    )
}